<div class="cooking-container">
  <div class="cooking-header" (swipedown)="backToEdit()">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>ویرایش</p>
    </div>
    <img
      src="assets/cookingbook/angle-down.svg"
      (click)="backToEdit()"
      alt=""
    />
  </div>
  <div *ngFor="let ratio of food?.foodUnitRatioArray" class="cooking-ratio">
    <div (click)="changeCookingUnit(ratio.unitId._id)">
      <img
        src="assets/cookingbook/circle.svg"
        *ngIf="ratio?.unitId._id != unit._id"
        alt=""
      />
      <img
        src="assets/cookingbook/circle_true.svg"
        *ngIf="ratio?.unitId._id == unit._id"
        alt=""
      />

      <p>
        {{ ratio?.unitId.name }}
      </p>
    </div>
  </div>
</div>
